import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "sr-only" }
const _hoisted_2 = ["href", "target"]
const _hoisted_3 = { class: "sr-only" }

import { defineEmits } from 'vue/dist/vue';

const buttonClass =
  ' align-center block p-0 h-8 w-8 border border-[1.5px] rounded-[40px] border-solid border-racq-light-blue-grey active:border-racq-blue-active active:bg-racq-pale-grey active:bg-racq-white hover:bg-racq-pale-grey disabled:opacity-50 input-focus';

const iconClass = 'bg-icon-chevron icon w-[8.003px] h-[13.33px] bg-no-repeat bg-contain inline-block align-middle';

const containerClass = 'flex items-center justify-center w-8 h-8 shrink-0 aspect-square -mt-[1px]';


export default /*@__PURE__*/_defineComponent({
  __name: 'SSIconButton',
  props: {
    srOnlyDescription: {},
    link: {},
    target: {}
  },
  emits: ['onClick'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;



function onClick() {
  emit('onClick');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.link)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: _normalizeClass(buttonClass),
          onClick: onClick
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(containerClass)
          }, [
            _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.srOnlyDescription), 1),
            _createElementVNode("span", {
              class: _normalizeClass(iconClass)
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.link)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: _ctx.link,
          target: `${_ctx.target ? _ctx.target : '_self'}`,
          class: _normalizeClass(buttonClass)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(containerClass)
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.srOnlyDescription), 1),
            _createElementVNode("span", {
              class: _normalizeClass(iconClass)
            })
          ])
        ], 8, _hoisted_2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})